webpackJsonp([70144966829960],{

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 1260, margin: '0 auto' } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Contact | Find Growth Tools'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { basic: true },
	      _react2.default.createElement(
	        _semanticUiReact.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Breadcrumb.Section,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', style: { color: '#dcddde' } },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	            'Home'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      { style: {
	          fontSize: '3.25rem',
	          color: '#fff'
	        } },
	      'Get in touch'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 960, margin: '0 auto' } },
	      _react2.default.createElement(
	        'p',
	        { style: { fontSize: '1.25em', color: '#fff' } },
	        'Questions, feedback, or just want to say hi? Get in touch using the form below.'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            {
	              name: 'contactForm'
	              // netlify-honeypot="bot-field"
	              , action: '/thanks'
	              // netlify
	              , size: 'medium',
	              method: 'post',
	              'data-netlify': 'true',
	              'data-netlify-honeypot': 'bot-field'
	            },
	            _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contactForm' }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              fluid: true,
	              type: 'text',
	              label: 'Your Name',
	              required: 'true',
	              placeholder: 'Your Name',
	              name: 'name'
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.TextArea, { label: 'Your message', required: 'true', placeholder: 'Your message', name: 'message' }),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                null,
	                _react2.default.createElement(_semanticUiReact.Form.Input, {
	                  type: 'email',
	                  label: 'Your email',
	                  required: 'true',
	                  placeholder: 'Your Email',
	                  name: 'email'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { primary: true, type: 'submit' },
	              'Send message'
	            ),
	            _react2.default.createElement(
	              'p',
	              {
	                style: {
	                  display: 'none'
	                }
	              },
	              _react2.default.createElement('input', { name: 'bot-field' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-713f9b69f01b07ac8407.js